angular.module('st')
    .controller('crewardsLocationsController', [
        '$rootScope', '$scope', '$http', 
        function ($rootScope, $scope, $http) {
            var ctrl = this;
            $scope.addLocationVisible = false;
            $scope.addLocationProcessing = false;
            $scope.removeLocationProcessing = false;

            ctrl.SetModel = function (savedLocations, siteGroups) {
                $scope.savedLocations = savedLocations;
                $scope.siteGroups = siteGroups;
            }
            
            ctrl.AddLocation = function (location) {
                if ($scope.addLocationProcessing == false) {
                    $scope.addLocationProcessing = true;
                    $scope.addLocationFeedback = 'Adding location...';
                    $http.post("/rpc/membership/account/location-preferences/add/" + location.vistaID)
                        .then(function (data) {
                            if (data.data.Success == true) {
                                $scope.addLocationFeedback = '';
                                $scope.addLocationProcessing = false;
                                $scope.savedLocations.push(location);
                            } else {
                                // vista error
                                $scope.addLocationProcessing = false;
                                $scope.addLocationFeedback = 'Error: ' + data.data.Message;
                            }
                        }).catch(function (error) {
                            // our server error
                            $scope.addLocationProcessing = false;
                            $scope.addLocationFeedback = 'Error occurred while trying to add location.'
                        })
                }
            }

            ctrl.UpdateModelPostRemove = function (location) {
                for (var i = 0; i < $scope.savedLocations.length; i++) {
                    if ($scope.savedLocations[i].vistaID == location.vistaID) {
                        $scope.savedLocations.splice(i, 1);
                    }
                }
            }

            ctrl.RemoveLocation = function (location) {
                if ($scope.removeLocationProcessing == false) {
                    $scope.removeLocationProcessing = true;
                    $scope.removeLocationFeedback = 'Removing location...';
                    $http.post("/rpc/membership/account/location-preferences/remove/" + location.vistaID)
                        .then(function (data) {
                            if (data.data.Success == true) {
                                $scope.removeLocationFeedback = '';
                                $scope.removeLocationProcessing = false;
                                ctrl.UpdateModelPostRemove(location);
                            } else {
                                // vista error
                                $scope.removeLocationProcessing = false;
                                $scope.removeLocationFeedback = 'Error: ' + data.data.Message;
                            }
                        }).catch(function (error) {
                            // our server error
                            $scope.removeLocationProcessing = false;
                            $scope.removeLocationFeedback = 'Error occurred while trying to add location.'
                        })
                }
            }

            ctrl.IsLocationSaved = function (location) {
                for (var i = 0; i < $scope.savedLocations.length; i++) {
                    var loopedLocation = $scope.savedLocations[i];
                    if (loopedLocation.vistaID == location.vistaID) {

                        return true;
                    }
                }

                return false;
            }

            ctrl.IsSiteGroupVisible = function(siteGroup){
                var cinemasToDisplay = 0;

                for (var i = 0; i < siteGroup.cinemas.length; i++) {
                    var cinema = siteGroup.cinemas[i];
                    var isSaved = ctrl.IsLocationSaved(cinema);

                    if (isSaved == false) {
                        cinemasToDisplay++;
                    }
                }

                return cinemasToDisplay > 0;
            }
            
        }
    ]);
